/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { imageDataRequestCategorySchema } from './ImageDataRequestCategorySchema'
import { imageDataRequestCollectionNameSchema } from './ImageDataRequestCollectionNameSchema'

export const imageDataRequestSchema = z.object({
	id: z.string(),
	name: z.string(),
	fileName: z.string(),
	category: imageDataRequestCategorySchema,
	mimeType: z.string().nullable().optional(),
	size: z.number(),
	humanReadableSize: z.string(),
	imgix_url: z.string(),
	collectionName: imageDataRequestCollectionNameSchema,
	width: z.number(),
	height: z.number(),
	isPlaceholder: z.boolean(),
	isGenerating: z.boolean(),
	createdAt: z.iso.datetime(),
	isGenerated: z.boolean().optional().default(false),
	startedGenerationAt: z.iso.datetime().nullable().optional(),
	finishedGenerationAt: z.iso.datetime().nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type ImageDataRequestSchema = z.infer<typeof imageDataRequestSchema>
